import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Dashboard from './components/Dashboard';
import Routines from './components/Routines';
import Register from './components/Register';
import Members from './components/Members';
import Sessions from './components/Stats';
import ManualLogin from './components/ManualLogin';
import PaymentOptions from './components/PaymentOptions';
import Reports from './components/Reports';
import MemberAttendanceTracker from './components/MemberAttendanceTracker';
import Data from './components/Data';
import Finances from './components/Finances';
import Diets from './components/Diets';
import DietPublic from './components/DietPublic';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/register" element={<Register />} />
          <Route path="/members" element={<Members />} />
          <Route path="/routines" element={<Routines />} />
          <Route path="/stats" element={<Sessions />} />
          <Route path="/login" element={<ManualLogin />} />
          <Route path="/payment" element={<PaymentOptions />} />
          <Route path="/reports" element={<Reports />} />
          <Route path="/assistance" element={<MemberAttendanceTracker />} />
          <Route path="/data" element={<Data />} />
          <Route path="/finances" element={<Finances />} />
          <Route path="/dietas" element={<Diets />} />
          <Route path="/dietas/ver/:slug" element={<DietPublic />} />
        </Routes>
      </div>
    </Router>
  );
}


export default App;
